/* eslint-disable */
import React from 'react'
import { object } from 'prop-types'

import { connect } from 'react-redux'
import { withContext } from '../../../utils/withContext'
import styles from './TrainersPage.styl'

const DATA = {
	"b200106d-6d2b-4389-a285-a91dd58b2ce4": {
		"name": "Paulo Pires",
		"image": "https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/paulo_pires_new.jpg",
		"pt": [
			"Treinador de UltraDistâncias, UltraTrail, Triatlo, Maratonas ... dos teus pequenos/grandes desafios.",
			"Licenciado em Desporto e Educação Física pela Faculdade de Desporto da Universidade do Porto, FADEUP, na opção de Desporto de Alto Rendimento.",
			"Mestre em Gestão Desportiva pela Faculdade de Desporto da Universidade do Porto, FADEUP.",
			"Professor de Educação Física/Desporto.",
			"Modalidades que praticou (como atleta, monitor, e/ou treinador): Atletismo, Natação, Polo-Aquático, Canoagem, Badminton, Montanhismo/Alpinismo."
		],
		"en": [
			"Coach of Ultra Distances, Ultra Trail, Triathlon, Marathons ... of your small / big challenges.",
			"Majored in Sport and Physical Education at FADEUP - Faculty of Sport, University of Porto, in the specialization of Performance Sport. Master in Sports Management by FADEUP - Faculty of Sport of the University of Porto.",
			"Experienced in: athletics, swimming, water polo, canoeing, badminton, mountaineering / climbing.",
			"Teacher of Physical Education/Sport.",
			"Athlete, monitor, and / or coach in the following activities: Athletics, Swimming, Polo-Aquatic, Canoeing, Badminton, Mountaineering / Mountaineering."
		]
	},
	"55b79d3b-481a-439d-a836-51d18ba4b6f1": {
		"name": "Lucinda Sousa",
		"image": "https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/lucinda_coach.jpg",
		"pt": [
			"Licenciada em Desporto e Educação Física pela Faculdade de Desporto da Universidade do Porto, FADEUP.",
			"Mestre em Atividade Física Adaptada, pela Faculdade de Desporto Da Universidade do Porto, FADEUP.",
			"Professora de Educação Física e de Educação Especial;",
			"Coordenadora técnica, durante vários anos de uma escola de atividades aquáticas;",
			"Experiência no ensino e treino de várias atividades, nomeadamente da natação, desporto adaptado, atletismo de estrada, trail, ultratrail, treino personalizado.",
		],
		"en": [
			"Licenciada em Desporto e Educação Física pela Faculdade de Desporto da Universidade do Porto, FADEUP.",
			"Mestre em Atividade Física Adaptada, pela Faculdade de Desporto Da Universidade do Porto, FADEUP.",
			"Professora de Educação Física e de Educação Especial;",
			"Coordenadora técnica, durante vários anos de uma escola de atividades aquáticas;",
			"Experiência no ensino e treino de várias atividades, nomeadamente da natação, desporto adaptado, atletismo de estrada, trail, ultratrail, treino personalizado.",
		]
	},
	"21b8f1a3-3afd-48a7-8a5e-ba4ebef16c50": {
		"name": "Armando Teixeira",
		"image": "https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/armando_.jpg",
	},
	"18719889-8e9e-4fd1-ac42-0f81e473d0f9": {
		"name": "João Colaço",
		"image": "https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/joaocolaco-clean_1476222692.jpg"
	}
}

class TrainersPage extends React.Component {

	static fetchQueries = [
		'services/$id'
	]

	static propTypes = {
		trainer: object,
		context: object
	}

	static displayName = 'TrainersPage'

	render() {
		const { trainer, context: { i18n, locale } } = this.props
		const { description, name, id } = (trainer || {})
		console.log(trainer)
		return (
			<div className={ styles['section'] }>
				<div className={ styles['content'] }>
					<div className={ styles['description-container'] }>
						<h2>{ DATA[id] ? DATA[id].name : null }</h2>
						<ul className={ styles['results-list'] }>
							{ DATA[id] ? (DATA[id][locale] || []).map((label, index) => (<li key={ index }>{ label }</li>)) : null }
						</ul>
					</div>
					{/* <div className={ styles['description-container'] }>
						<h2>{ i18n`curriculum_label` }</h2>
						<ul className={ styles['results-list'] }>
							<li>{ i18n`curriculum_results_label_1` }</li>
							<li>{ i18n`curriculum_results_label_2` }</li>
							<li>{ i18n`curriculum_results_label_3` }</li>
							<li>{ i18n`curriculum_results_label_4` }</li>
							<li>{ i18n`curriculum_results_label_5` }</li>
						</ul>
					</div> */}
					<div
						className={ styles['trainer'] }
						style={ { backgroundImage: `url(${ (DATA[id] || {}).image })` } }
					/>
				</div>
			</div>
		)
	}
}


const mapStateToProps = state => ({
	trainer: state.fetch.results[TrainersPage.fetchQueries[0]]
})

export default withContext(connect(mapStateToProps)(TrainersPage))



// WEBPACK FOOTER //
// ./src/client/website/pages/TrainersPage/TrainersPage.js